import { makeStyles } from "@mui/styles";
import theme from "src/theme";

export const useStyles = makeStyles({
    containerSideBar: {
        position: "fixed",
        left: 0,
        top: "50%",
        transform: "translate(calc(-100% + 18px), -50%)",
        zIndex: 100,
        background: "#1B1B1C",
        borderTop: "1px solid #C6FFE7",
        borderRight: "1px solid #C6FFE7",
        borderBottom: "1px solid #C6FFE7",
        borderRadius: 6,
        display: "grid",
        gridTemplateColumns: "1fr",
        gridRowGap: "20px",
        alignItems: "center",
        padding: "30px 15px 30px 8px",
        transition: "0.5s ease",
        [theme.breakpoints.up(1800)]: {
            transform: "translate(calc(-100% + 30px), -50%)",
            padding: "24px",
            gridRowGap: "14px",
        },
        "&.open": {
            transform: "translate(0%, -50%)",
        },
    },
});
